<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <div>
      <b-form @submit.prevent="submitForm">
        <b-form-row>
          <b-col>
            <lg-form-const-select v-model="form.tipoEndereco.id" id="tipoEndereco" :options="optionsFilterEndereco"
              label="Tipo de Endereço:*" />
          </b-col>
          <b-col>
            <b-form-group class='col-12' label="Endereço Principal">
              <b-form-checkbox v-model="form.enderecoPrincipal"></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <lg-form-input invalidFeedback="Informe um CEP válido!" description=" " required v-model="form.cep"
              label="CEP: *" :error="cepValidation()" :formatter="cepFormatter"></lg-form-input>
          </b-col>
          <b-col>
            <lg-form-input description=" " v-model="form.caixaPostal" label="Caixa Postal:"></lg-form-input>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <lg-finder-page-unidade-federativa @input="handleUnidadeFederativa" v-model="form.uf" :value="form.uf" label="UF:*" id="finderUf"
              invalidFeedback="UF deve ser informada!" description="" :prefix="updatedPrefix"  />
          </b-col>
          <b-col>
            <lg-finder-page-cidade :estado="estado" v-model="form.cidade" :value="form.cidade" label="Cidade:*" id="finderCidade"
              invalidFeedback="Cidade deve ser informada!" description="" :prefix="updatedPrefix"
              v-if="isUfSelected" @onselect="handleCidadeSelect" class='col-12' />

              <lg-finder-page-cidade :disabled="true" :estado="codEstado" v-model="form.cidade" :value="form.cidade" label="Cidade:*" id="finderCidade"
              invalidFeedback="Cidade deve ser informada!" description="" :prefix="updatedPrefix"
              v-if="!isUfSelected" @onselect="handleCidadeSelect" class='col-12' />
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <lg-form-input description=" " required v-model="form.logradouro" label="Logradouro: *"></lg-form-input>
          </b-col>
          <b-col>
            <lg-form-input description=" " required v-model="form.bairro" label="Bairro: *"></lg-form-input>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <lg-form-input description=" " required v-model="form.numero" label="Nº: *"></lg-form-input>
          </b-col>
          <b-col>
            <lg-form-input description=" " v-model="form.complemento" label="Complemento:"></lg-form-input>
          </b-col>
        </b-form-row>

        <div class="d-flex justify-content-center mt-3">
          <b-button id="salvarEndereco" type="submit" variant="success" style="height: 30px" pill size="sm">
            <div class="btn-size-alinhamento">
              <b-icon icon="check-circle" />
            </div>
            <b-tooltip target="salvarEndereco" title="Salvar" triggers="hover"></b-tooltip>

          </b-button>
          <b-button id="cancelarEndereco" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
            <div class="btn-size-alinhamento">
              <b-icon icon="x-circle" />
            </div>
            <b-tooltip target="cancelarEndereco" title="Cancelar" triggers="hover"></b-tooltip>

          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPageUnidadeFederativa from "@/components/Finders/LgFinderPageUnidadeFederativa.vue";
import LgFinderPageCidade from "@/components/Finders/LgFinderPageCidade.vue";
import ResourceService from "@/core/api/ResourceService";
import API from "@/core/api/index";

export default {
  components: {
    LgFormConstSelect,
    LgFormInput,
    LgFinderPageUnidadeFederativa,
    LgFinderPageCidade,
  },
  props: {
    id: Number,
    prefix: Array,
    codEmpresa: Number,
  },
  data() {
    return {
      estado: null,
      form: {
        uf: {},
        cep: "",
        caixaPostal: "",
        enderecoPrincipal: false,
        cidade: {},
        logradouro: "",
        bairro: "",
        numero: "",
        complemento: "",
        tipoEndereco: {},
        codEmpresa: this.codEmpresa,
      },

      showModal: true,
      optionsFilterEndereco: [],
    };
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/endereco`);
    API.get(`/api/tipo-endereco`).then((response) => {
      this.optionsFilterEndereco = [
        { key: "endereco", text: "Selecione...", value: undefined },
        ...response.data.map((item) => ({
          key: "endereco",
          text: item.descricao,
          value: item.id,
        })),
      ];
    });

    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      data.cep = this.cepFormatter(data.cep);
      this.form = data;
      this.form.codEmpresa = this.codEmpresa;
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastros"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
    isUfSelected() {
      return !!this.form.uf.id;
    },
    codEstado(){
      return this.estado;
    }
  },
  methods: {
    handleUnidadeFederativa(item){
      this.estado = item.id;

    },
    cepFormatter(value) {
      return value.replace(/\D/g, "").replace(/(\d{5})(\d{3})/, "$1-$2");
    },
    cepValidation() {
      if (this.form.cep.length > 0 && this.form.cep.length !== 9) {
        return { $error: true };
      }
      return { $error: false };
    },

    async submitForm() {


      if(!this.form.tipoEndereco || !this.form.tipoEndereco.id){
        this.$notify({
          type: "danger",
          message: "Selecione um Tipo de Endereço.",
        });
        return;

      }

      if(!this.form.cidade || this.form.cidade.cod){
        this.$notify({
          type: "danger",
          message: "Selecione uma Cidade.",
        });
        return;

      }
      try {
        await this.$service.save(this.form);
        this.$notify({
          type: "success",
          message: 'Registro salvo com sucesso'
        });
        this.cancelar();

      } catch (e) {
        this.$notify({
          type: "danger",
          message: 'Este registro já está cadastrado'
        });
        return;
      }

    },
    cancelar() {
      this.$emit("fechar");
    },
    handleCidadeSelect(item) {
      this.form.cidade = item.municipio;
      this.cidadeObject = item;
    },
  },
};
</script>
